import React, { useContext, useState } from 'react';
import { layoutContext } from '../RAIAssessment';
import SingleOption from './SingleOption';
import SingleOptionMedia from './SingleOptionMedia';
import Slider from './Slider';
import '../Questions/styles/Questions.scss';
import '../Questions/styles/Answer.scss';
import PublicImage from 'src/common/components/PublicImage';
import { Button } from 'carbon-components-react';
import { FormattedMessage } from 'react-intl';
import messages from '../../locales/messages';
import { ArrowLeft20, ArrowRight20 } from '@carbon/icons-react';
import { Scenario } from '../../data/constants';
import { useEffect } from 'react';

interface questionsProps {
  contents: any;
}

const Questions = (questionsProps: questionsProps) => {
  const { contents } = questionsProps;
  const [qPath, setQPath] = useState(['q1']);
  const [disableNext, setDisableNext] = useState(true);
  const {
    setCurrentScenario,
    selectedItems,
    setSelectedOption,
    selectedOption,
    questionId,
    setQuestionId,
  } = useContext(layoutContext);

  useEffect(() => {
    if (selectedItems[questionId as keyof typeof selectedItems]) {
      setDisableNext(false);
    } else {
      setDisableNext(true);
    }
  });

  const handleSelectedOptins = (qId: string) => {
    contents.forEach((question: any) => {
      if (question.id === qId) {
        if (selectedItems[qId as keyof typeof selectedItems]) {
          const { optionId } = selectedItems[qId as keyof typeof selectedItems];
          if (question.options) {
            question.options.forEach((option: any) => {
              if (option.optionId === optionId) {
                setSelectedOption(option);
              }
            });
          } else {
            ['10', '20', '30'].forEach((option: string) => {
              if (option == optionId) {
                setSelectedOption({
                  optionId: option,
                  nextStep: question.nextStep,
                });
              }
            });
          }
        }
      }
    });
  };

  const handlePrevious = (qId: string) => {
    const path = qPath.splice(0, qPath.length - 1);
    setQPath(path);
    setQuestionId(qId);
    handleSelectedOptins(qId);
  };

  const handleNext = (qId: string) => {
    if (qId === 'success') {
      setSelectedOption({
        optionId: '',
        nextStep: '',
      });
      return setCurrentScenario(Scenario.success);
    } else {
      setQPath([...qPath, qId]), setQuestionId(qId);
      handleSelectedOptins(qId);
    }
  };

  return (
    <div style={{ margin: 0 }}>
      {contents.map((question: any, i: number) => {
        if (question.id === questionId) {
          return (
            <div className="bx--row rai-assessment" key={questionId}>
              <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-16 rai-assessment__question-wrapper">
                <p className="rai-assessment__question-indicator">
                  {question.questionNumber} of 9
                </p>
                <h4 className="rai-assessment__question-text">
                  {question.title}
                </h4>
                <PublicImage
                  imgPath={question.imageSrc}
                  widgetId="rai-assessment"
                  alt={'alt'}
                  className="rai-assessment__question-image"
                />
              </div>
              <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-16 rai-assessment__answer-wrapper">
                {(() => {
                  switch (question.type) {
                    case 'single-option':
                      return <SingleOption question={question} />;
                    case 'single-option-media':
                      return <SingleOptionMedia question={question} />;
                    case 'slider':
                      return <Slider data={question} />;
                    default:
                      return null;
                  }
                })()}
                <div className="rai-assessment__question-cta">
                  <Button
                    kind="secondary"
                    disabled={i <= 0}
                    className={
                      i > 0
                        ? 'rai-assessment__question-cta-secondary'
                        : 'rai-assessment__question-cta-hidden'
                    }
                    onClick={() => handlePrevious(qPath[qPath.length - 2])}
                  >
                    <div className="rai-assessment__question-cta-secondary-icon">
                      <ArrowLeft20 />
                    </div>
                    <FormattedMessage {...messages.previousButton} />
                  </Button>
                  <Button
                    disabled={disableNext}
                    className="rai-assessment__question-cta-primary"
                    onClick={() => handleNext(selectedOption.nextStep)}
                    renderIcon={ArrowRight20}
                  >
                    <FormattedMessage {...messages.nextButton} />
                  </Button>
                </div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default Questions;
